// src/data/angels.js

export const angels = [
    // --- 🛡️ S (Strength: 용기/보호) 타입 시작 ---
    {
        id: "S_Spring_01",
        name: "봄날의 싹을 틔우는 거인",
        rank: "Normal",
        type: "S",
        season: "Spring",
        image: "/images/s_spring_01.jpg",
        description: "얼어붙은 땅을 두드려 생명을 깨우는 투박한 손길의 수호자입니다.",
        advice: "지금 당신의 작은 한 걸음이 단단한 대지를 깨우고 있습니다. 스스로의 힘을 믿고 멈추지 마세요."
    },
    {
        id: "S_Spring_02",
        name: "풀꽃 갑옷을 입은 기사",
        rank: "Normal",
        type: "S",
        season: "Spring",
        image: "/images/s_spring_02.jpg",
        description: "여린 생명들이 다치지 않게 온몸으로 비바람을 막아주는 용감한 기사입니다.",
        advice: "당신은 누군가를 지킬 때 가장 강해지는 사람입니다. 그 따뜻한 용기가 당신을 지켜줄 거예요."
    },
    {
        id: "S_Summer_01",
        name: "태양을 품은 바위 산맥",
        rank: "Normal",
        type: "S",
        season: "Summer",
        image: "/images/s_summer_01.jpg",
        description: "폭염 속에서도 흔들림 없이 우뚝 솟아 당신에게 그늘을 내어주는 커다란 벽입니다.",
        advice: "세상의 소란함에 흔들리지 마세요. 당신은 이미 산처럼 거대하고 단단한 존재입니다."
    },
    {
        id: "S_Summer_02",
        name: "파도를 잠재우는 선장",
        rank: "Normal",
        type: "S",
        season: "Summer",
        image: "/images/s_summer_02.jpg",
        description: "거친 운명의 파도가 몰아칠 때, 배의 키를 단단히 잡고 나아갈 방향을 일러줍니다.",
        advice: "폭풍우는 곧 지나갈 것입니다. 당신의 손에 쥐어진 키를 믿고 끝까지 항해를 계속하세요."
    },
    {
        id: "S_Autumn_01",
        name: "황금 들판의 허수아비 파수꾼",
        rank: "Normal",
        type: "S",
        season: "Autumn",
        image: "/images/s_autumn_01.jpg",
        description: "소박한 모습이지만, 당신이 일궈온 소중한 결실을 지키기 위해 밤낮없이 깨어있습니다.",
        advice: "화려하지 않아도 괜찮습니다. 당신이 묵묵히 지켜온 것들이 곧 아름다운 보상이 될 테니까요."
    },
    {
        id: "S_Autumn_02",
        name: "고목의 뿌리를 지키는 영혼",
        rank: "Normal",
        type: "S",
        season: "Autumn",
        image: "/images/s_autumn_02.jpg",
        description: "세월의 풍파를 견뎌낸 고목처럼, 당신의 근간이 흔들리지 않도록 깊게 뿌리내려 줍니다.",
        advice: "보이지 않는 곳에서 쌓아온 당신의 내공이 시련 속에서 당신을 지탱하는 가장 큰 힘이 됩니다."
    },
    {
        id: "S_Winter_01",
        name: "만년설의 눈보라 방패",
        rank: "Normal",
        type: "S",
        season: "Winter",
        image: "/images/s_winter_01.jpg",
        description: "어떤 차가운 시련도 뚫지 못하게 당신의 주변을 하얀 숨결로 감싸 보호합니다.",
        advice: "세상이 차갑게 느껴질 때, 당신을 감싸는 이 따뜻한 결계 안에서 잠시 숨을 고르셔도 됩니다."
    },
    {
        id: "S_Winter_02",
        name: "침묵하는 얼음 호수의 문지기",
        rank: "Normal",
        type: "S",
        season: "Winter",
        image: "/images/s_winter_02.jpg",
        description: "고요한 겨울밤, 당신의 평온한 잠자리를 지키기 위해 성문을 지키는 기사입니다.",
        advice: "조급해할 필요 없습니다. 가장 깊은 어둠 속에서도 당신의 평화는 완벽하게 보호받고 있습니다."
    },
    {
        id: "S_Rare_01",
        name: "천공의 성을 지키는 무쇠 정령",
        rank: "Rare",
        type: "S",
        season: "Any", // 희귀는 어떤 계절에도 나타날 수 있게 'Any' 혹은 특정 계절 부여
        image: "/images/s_rare_01.jpg",
        description: "수백 년의 시간을 넘어 오직 당신만을 지키기로 맹세한 전설의 파수꾼입니다.",
        advice: "당신은 존재만으로도 지켜질 가치가 있는 소중한 사람입니다. 이제 내가 당신의 검과 방패가 되겠습니다."
    },
    // --- 🛡️ S 타입 끝 (이 뒤에 M 타입을 이어서 추가할 예정입니다) ---

    // src/data/angels.js (S타입 아래에 이어서 붙여넣으세요)

  // --- 📖 M (Magic: 지혜/통찰) 타입 시작 ---
  {
        id: "M_Spring_01",
        name: "꽃가루 예언의 술사",
        rank: "Normal",
        type: "M",
        season: "Spring",
        image: "/images/m_spring_01.jpg",
        description: "흩날리는 꽃가루의 궤적을 읽어 당신의 새로운 시작을 예견합니다.",
        advice: "사소한 변화에 귀를 기울이세요. 그 안에 당신이 찾던 답이 들어 있습니다."
    },
    {
        id: "M_Spring_02",
        name: "아침 이슬의 현자",
        rank: "Normal",
        type: "M",
        season: "Spring",
        image: "/images/m_spring_02.jpg",
        description: "잎사귀에 맺힌 이슬처럼 투명하고 맑은 정신으로 세상을 비춰줍니다.",
        advice: "복잡한 생각은 잠시 내려두세요. 마음이 맑아질 때 비로소 진실이 보입니다."
    },
    {
        id: "M_Summer_01",
        name: "반딧불이 서재의 주인",
        rank: "Normal",
        type: "M",
        season: "Summer",
        image: "/images/m_summer_01.jpg",
        description: "여름밤을 수놓는 반딧불이들의 빛을 모아 오래된 지혜의 책을 읽어줍니다.",
        advice: "어둠 속에서도 빛나는 지식은 당신을 가장 안전한 길로 인도할 것입니다."
    },
    {
        id: "M_Summer_02",
        name: "소나기 뒤의 무지개 연금술사",
        rank: "Normal",
        type: "M",
        season: "Summer",
        image: "/images/m_summer_02.jpg",
        description: "갑작스러운 소나기를 찬란한 무지개로 바꾸는 긍정의 마법을 부립니다.",
        advice: "지금의 고난은 더 큰 아름다움을 만들기 위한 필수적인 과정일 뿐입니다."
    },
    {
        id: "M_Autumn_01",
        name: "낙엽 서신을 쓰는 학자",
        rank: "Normal",
        type: "M",
        season: "Autumn",
        image: "/images/m_autumn_01.jpg",
        description: "떨어지는 낙엽 하나하나에 담긴 세상의 이치를 연구하고 기록합니다.",
        advice: "비워내는 연습을 하세요. 나무가 잎을 떨구듯, 당신도 더 큰 성장을 위해 비워야 할 때입니다."
    },
    {
        id: "M_Autumn_02",
        name: "안개 자욱한 숲의 길잡이",
        rank: "Normal",
        type: "M",
        season: "Autumn",
        image: "/images/m_autumn_02.jpg",
        description: "짙은 안개 속에서도 당신의 영혼이 가야 할 길을 정확히 짚어냅니다.",
        advice: "앞이 보이지 않는다고 두려워 마세요. 당신의 직관이 가장 정확한 나침반입니다."
    },
    {
        id: "M_Winter_01",
        name: "눈 결정의 기하학자",
        rank: "Normal",
        type: "M",
        season: "Winter",
        image: "/images/m_winter_01.jpg",
        description: "눈 결정 하나에 담긴 완벽한 질서를 통해 세상의 법칙을 가르쳐줍니다.",
        advice: "모든 일에는 때와 순서가 있습니다. 자연의 섭리처럼 차분히 기다려 보세요."
    },
    {
        id: "M_Winter_02",
        name: "등불을 든 북극성 감시자",
        rank: "Normal",
        type: "M",
        season: "Winter",
        image: "/images/m_winter_02.jpg",
        description: "가장 춥고 긴 밤, 흔들리지 않는 북극성의 빛으로 당신의 방향을 지킵니다.",
        advice: "주변의 시선에 흔들리지 마세요. 당신만의 신념이 곧 당신의 길입니다."
    },
    {
        id: "M_Rare_01",
        name: "푸른 달의 대마법사",
        rank: "Rare",
        type: "M",
        season: "Any",
        image: "/images/m_rare_01.jpg",
        description: "달의 주기를 다스리며 시간과 공간을 넘어선 지혜를 선사하는 전설의 마법사입니다.",
        advice: "당신은 세상을 바꿀 수 있는 통찰력을 가졌습니다. 그 지혜를 선한 곳에 사용하세요."
    },
    // --- 📖 M 타입 끝 ---

    // src/data/angels.js (M타입 아래에 이어서 붙여넣으세요)

    // --- 🍃 A (Agility: 자유/변화) 타입 시작 ---
    {
        id: "A_Spring_01",
        name: "민들레 홀씨 여행자",
        rank: "Normal",
        type: "A",
        season: "Spring",
        image: "/images/a_spring_01.jpg",
        description: "봄바람을 타고 어디든 가볍게 날아가는 호기심 많은 탐험가입니다.",
        advice: "한곳에 머물지 않아도 괜찮아요. 당신이 닿는 모든 곳이 새로운 시작이 될 거예요."
    },
    {
        id: "A_Spring_02",
        name: "버들강아지 춤꾼",
        rank: "Normal",
        type: "A",
        season: "Spring",
        image: "/images/a_spring_02.jpg",
        description: "시냇가 버드나무 사이를 누비며 생동감 넘치는 봄의 춤을 춥니다.",
        advice: "지루한 일상에 리듬을 더해보세요. 당신의 유연함이 경직된 상황을 바꿔놓을 것입니다."
    },
    {
        id: "A_Summer_01",
        name: "뭉게구름 서퍼",
        rank: "Normal",
        type: "A",
        season: "Summer",
        image: "/images/a_summer_01.jpg",
        description: "높게 솟은 여름 뭉게구름 위를 파도타듯 누비는 자유로운 영혼입니다.",
        advice: "높은 곳에서 세상을 내려다보세요. 지금의 고민이 생각보다 작다는 걸 알게 될 거예요."
    },
    {
        id: "A_Summer_02",
        name: "여름 숲의 장난꾸러기 바람",
        rank: "Normal",
        type: "A",
        season: "Summer",
        image: "/images/a_summer_02.jpg",
        description: "우거진 숲의 나뭇잎들을 흔들며 시원한 웃음을 전해주는 쾌활한 정령입니다.",
        advice: "심각해질 필요 없어요. 가끔은 장난스러운 시도가 가장 멋진 해결책이 되기도 합니다."
    },
    {
        id: "A_Autumn_01",
        name: "황금빛 비행선 조종사",
        rank: "Normal",
        type: "A",
        season: "Autumn",
        image: "/images/a_autumn_01.jpg",
        description: "가을 산맥의 능선을 따라 비행하며 세상의 변화를 가장 먼저 관찰합니다.",
        advice: "변화의 흐름을 타는 법을 배우세요. 저항하기보다 흐름에 몸을 맡길 때 더 멀리 갑니다."
    },
    {
        id: "A_Autumn_02",
        name: "노을을 배달하는 우체부",
        rank: "Normal",
        type: "A",
        season: "Autumn",
        image: "/images/a_autumn_02.jpg",
        description: "하늘이 붉게 물들 때, 그리운 소식들을 날개에 실어 나르는 여행가입니다.",
        advice: "소중한 인연에게 당신의 마음을 전하세요. 바람이 당신의 진심을 실어다 줄 것입니다."
    },
    {
        id: "A_Winter_01",
        name: "은하수 스케이트 보더",
        rank: "Normal",
        type: "A",
        season: "Winter",
        image: "/images/a_winter_01.jpg",
        description: "얼어붙은 밤하늘의 은하수 위를 미끄러지듯 달리는 속도감 넘치는 천사입니다.",
        advice: "망설이지 말고 속도를 내보세요. 당신의 빠른 판단이 얼어붙은 상황을 깨뜨릴 것입니다."
    },
    {
        id: "A_Winter_02",
        name: "북극광의 무희",
        rank: "Normal",
        type: "A",
        season: "Winter",
        image: "/images/a_winter_02.jpg",
        description: "차가운 겨울 밤하늘에 화려한 오로라를 그리며 빛의 춤을 선보입니다.",
        advice: "어둠 속에서도 당신만의 색깔을 드러내세요. 당신은 존재만으로도 눈부신 빛입니다."
    },
    {
        id: "A_Rare_01",
        name: "북서풍의 지배자",
        rank: "Rare",
        type: "A",
        season: "Any",
        image: "/images/a_rare_01.jpg",
        description: "세상의 모든 바람을 다스리며, 경계를 허물고 어디로든 데려다주는 전설의 비행사입니다.",
        advice: "당신을 가두는 모든 틀을 벗어던지세요. 당신에겐 그 어떤 한계도 존재하지 않습니다."
    },
    // --- 🍃 A 타입 끝 ---
];